import { UmbracoImageCrop } from "../models/media.interface";

const getImageAspectRatio = (crop: UmbracoImageCrop | undefined, imageWidth?: string, imageHeight?: string): any => {
    if (crop) {
        return {
            aspectRatioX: crop.width,
            aspectRatioY: crop.height,
        };
    } else if (imageWidth && Number(imageWidth) > 0 && imageHeight && Number(imageHeight) > 0) {
        return {
            aspectRatioX: imageWidth,
            aspectRatioY: imageHeight,
        };
    } else {
        return {
            aspectRatioX: 16,
            aspectRatioY: 9,
        };
    }
};

export default getImageAspectRatio;
